import React from 'react';
import SettingsPage from '../../components/settings/SettingsPage';

const sections = [
    {
        key: 'store',
        titleEn: 'Store',
        titleAr: 'المتجر',
        descriptionEn: 'Public store identity — name, logo, description.',
        descriptionAr: 'هوية المتجر العامة — الاسم، الشعار، الوصف.',
    },
    {
        key: 'general',
        titleEn: 'General',
        titleAr: 'عام',
    },
    {
        key: 'currency',
        titleEn: 'Currency',
        titleAr: 'العملة',
    },
    {
        key: 'locale',
        titleEn: 'Language & locale',
        titleAr: 'اللغة والمنطقة',
    },
    {
        key: 'seo',
        titleEn: 'SEO',
        titleAr: 'تهيئة محركات البحث',
    },
];

const GeneralSettings = () => (
    <SettingsPage
        titleEn="General Settings"
        titleAr="الإعدادات العامة"
        descriptionEn="Store identity, default currency, and other tenant-wide preferences."
        descriptionAr="هوية المتجر، العملة الافتراضية، والإعدادات العامة للحساب."
        sections={sections}
    />
);

export default GeneralSettings;
